import { FaUsers, FaUserPlus, FaTags, FaSearch } from "react-icons/fa";

const Dashboard = () => {
  const stats = [
    {
      id: 1,
      label: "Total Users",
      value: "24,532",
      icon: <FaUsers className="text-blue-600 text-2xl sm:text-3xl" />,
      trend: "+12% from last month",
    },
    {
      id: 2,
      label: "New Users (This Month)",
      value: "1,245",
      icon: <FaUserPlus className="text-green-600 text-2xl sm:text-3xl" />,
      trend: "+8% vs last month",
    },
    {
      id: 3,
      label: "New Deals",
      value: "312",
      icon: <FaTags className="text-purple-600 text-2xl sm:text-3xl" />,
      trend: "+5% in last 7 days",
    },
    {
      id: 4,
      label: "Daily Searches",
      value: "18,920",
      icon: <FaSearch className="text-pink-600 text-2xl sm:text-3xl" />,
      trend: "+15% this week",
    },
  ];

  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 xl:grid-cols-4 gap-4 sm:gap-6 mb-8">
      {stats.map((stat) => (
        <div
          key={stat.id}
          className="rounded-2xl p-4 sm:p-6 shadow-md bg-white"
        >
          <div className="flex justify-between items-center">
            <div>
              <p className="text-gray-600 text-xs sm:text-sm">{stat.label}</p>
              <h3 className="text-lg sm:text-2xl font-bold text-gray-900">
                {stat.value}
              </h3>
              <p className="text-[10px] sm:text-xs text-gray-500 mt-1">
                {stat.trend}
              </p>
            </div>
            {stat.icon}
          </div>
        </div>
      ))}
    </div>
  );
};

export default Dashboard;
